"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createShopAction", {
  enumerable: true,
  get: function get() {
    return _slice.createShopAction;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _view["default"];
  }
});
Object.defineProperty(exports, "getShops", {
  enumerable: true,
  get: function get() {
    return _commands.getShops;
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "onModeration", {
  enumerable: true,
  get: function get() {
    return _commands.onModeration;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "resetStateAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetStateAction;
  }
});
Object.defineProperty(exports, "selectCategories", {
  enumerable: true,
  get: function get() {
    return _slice.selectCategories;
  }
});
Object.defineProperty(exports, "selectItems", {
  enumerable: true,
  get: function get() {
    return _slice.selectItems;
  }
});
Object.defineProperty(exports, "selectPaging", {
  enumerable: true,
  get: function get() {
    return _slice.selectPaging;
  }
});
Object.defineProperty(exports, "selectPreloadingProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectPreloadingProcess;
  }
});
Object.defineProperty(exports, "selectShopsInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectShopsInProcess;
  }
});
Object.defineProperty(exports, "selectStatus", {
  enumerable: true,
  get: function get() {
    return _slice.selectStatus;
  }
});
Object.defineProperty(exports, "setPreloadingProcess", {
  enumerable: true,
  get: function get() {
    return _slice.setPreloadingProcess;
  }
});
Object.defineProperty(exports, "setStatus", {
  enumerable: true,
  get: function get() {
    return _slice.setStatus;
  }
});

var _view = _interopRequireDefault(require("./view"));

var _slice = require("./store/slice");

var _commands = require("./store/commands");